import React, { useState } from "react";
import UserProfile from "./UserProfile";
import Button from "./../common/Button";
import { ImageGallery, VideoGallery } from "./../postdetail/MediaGallery";
import HtmlReader from "./../../components/common/HtmlReader"
import { markReadPost } from "../../api/postsApi"; // Import hàm markReadPost
import { useUser } from "./../../context/UserContext";

const PostContainer = ({
  postId,
  initialReadStatus,
  title,
  author,
  date,
  time,
  postCount,
  page,
  totalPages,
  content,
  profileImage,
  isOnline,
  userPosts,
  registrationDate,
  images,
  videos
}) => {
  const [isRead, setIsRead] = useState(initialReadStatus); // Quản lý trạng thái đã đọc
  const { user } = useUser();
  const handleMarkRead = async () => {
    try {
      await markReadPost({ PostId: postId, IsRead: !isRead, UserId: user.guid });
      setIsRead(!isRead);
    } catch (error) {
      console.error("Error marking post as read/unread", error);
    }
  };
  return (
    <article className="p-6 mt-6 w-full rounded-2xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
      <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
        <div className="flex flex-col flex-1 shrink basis-6 min-w-60 max-md:max-w-full">
          <h1 className="text-3xl font-semibold leading-none text-gray-700 max-md:max-w-full">
            {title}
          </h1>
          <button onClick={handleMarkRead} className="ml-2">
            {isRead ? '🔵' : '⚪'} {/* Icon read/unread */}
            {isRead ? 'Đã đọc' : 'Chưa đọc'} {/* Icon read/unread */}
          </button>
          <div className="flex flex-col self-start mt-4">
            <div className="flex gap-1 items-center">
              <div className="flex gap-1 items-start self-stretch my-auto text-sm font-medium leading-loose whitespace-nowrap">
                <span className="text-zinc-600">from</span>
                <span className="text-blue-500">{author}</span>
              </div>
              <div className="flex gap-2 justify-center items-center self-stretch p-1 my-auto w-3.5">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/cdb48d7769e2f15c2f2cabd1235c7486aa7027f48a84d2262f767210e06ac449?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"
                  alt="Separator dot"
                  className="object-contain self-stretch my-auto w-1.5 aspect-square"
                />
              </div>
              <time className="self-stretch my-auto text-sm leading-loose text-gray-400">
                {date}
              </time>
              <div className="flex gap-2 justify-center items-center self-stretch p-1 my-auto w-3.5">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/cdb48d7769e2f15c2f2cabd1235c7486aa7027f48a84d2262f767210e06ac449?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"
                  alt="Separator dot"
                  className="object-contain self-stretch my-auto w-1.5 aspect-square"
                />
              </div>
              <time className="self-stretch my-auto text-sm leading-loose text-gray-400">
                {time}
              </time>
            </div>
            <div className="flex gap-1 items-center self-start mt-2">
              <span className="self-stretch my-auto text-sm leading-loose text-gray-700">
                {postCount} posts
              </span>
              <div className="flex gap-2 justify-center items-center self-stretch p-1 my-auto w-3.5">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/cdb48d7769e2f15c2f2cabd1235c7486aa7027f48a84d2262f767210e06ac449?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"
                  alt="Separator dot"
                  className="object-contain self-stretch my-auto w-1.5 aspect-square"
                />
              </div>
              <span className="self-stretch my-auto text-sm leading-loose text-gray-700">
                page {page}
              </span>
              <div className="flex gap-2 justify-center items-center self-stretch p-1 my-auto w-3.5">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/cdb48d7769e2f15c2f2cabd1235c7486aa7027f48a84d2262f767210e06ac449?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"
                  alt="Separator dot"
                  className="object-contain self-stretch my-auto w-1.5 aspect-square"
                />
              </div>
              <span className="self-stretch my-auto text-sm leading-loose text-gray-700">
                from {totalPages}
              </span>
            </div>
          </div>
          <p className="mt-4 text-base leading-7 text-gray-700 max-md:max-w-full">
            <HtmlReader html={content} />

          </p>
        </div>
        <UserProfile
          username={author}
          isOnline={isOnline}
          postCount={userPosts}
          registrationDate={registrationDate}
          profileImage={profileImage}
        />
      </div>
      <ImageGallery
        images={images}
      />
      <VideoGallery
        videos={videos}
      />
      <div className="flex flex-wrap justify-between items-end mt-6 w-full text-sm leading-loose whitespace-nowrap min-h-[42px] max-md:max-w-full">
        <div className="flex flex-wrap flex-1 shrink gap-4 items-center basis-0 min-w-60 max-md:max-w-full">
          <div className="flex gap-2 items-start self-stretch my-auto text-gray-800">
            <div className="flex gap-0.5 items-center">
              <button
                aria-label="Like"
                className="flex shrink-0 self-stretch my-auto w-6 h-6"
              />
              <span className="self-stretch my-auto text-ellipsis">8th</span>
            </div>
            <div className="shrink-0 self-stretch w-0 h-6 bg-gray-200 border border-gray-200 border-solid" />
            <div className="flex gap-0.5 items-center">
              <button
                aria-label="Dislike"
                className="flex shrink-0 self-stretch my-auto w-6 h-6"
              />
              <span className="self-stretch my-auto text-ellipsis">3</span>
            </div>
          </div>
          <Button
            variant="primary"
            icon="message-edit"
            className="flex gap-2 justify-center items-center self-stretch px-4 py-2.5 my-auto font-medium text-white bg-rose-700 min-h-[42px] rounded-[400px]"
          >
            Answer
          </Button>
        </div>
        <div className="flex gap-3 items-center font-medium text-gray-700">
          <Button
            variant="neutral"
            icon="warning-2"
            className="flex gap-2 justify-center items-center self-stretch px-4 py-1.5 my-auto border border-gray-700 border-solid rounded-[400px]"
          >
            Report
          </Button>
        </div>
      </div>
    </article>
  );
};

export default PostContainer;
